import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Form,
  Select,
  Row,
  Col,
  Checkbox,
  Spin,
  Tooltip,
  Modal,
  Button,
  Divider,
  Input,
  Space,
} from "antd";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import InputField from "../common/htmlComponents/InputField";
import ButtonField from "../common/htmlComponents/ButtonField";
import { getRequest, patchRequest, postRequest } from "../axios";
import { Option } from "antd/lib/mentions";
import { SuccessNotificationMsg } from "../utils/Notifications";
import { authUserData } from "../utils/Helper";
import { PlusOutlined, PlusSquareFilled } from "@ant-design/icons";
import { t } from "i18next";
import NewRFQApproval from "./NewRFQApproval";
import ApprovalForRFQ from "./ApprovalForRFQ";
// import SelectVendorAddModal from "./SelectVendorAddModal";

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

const PoOrderApprovalRejection = () => {
  const { rfqId, id, resetToken, rfqNumber } = useParams();
  const navigate = useNavigate();
  const [getResponseData, setGetResponseData] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [rfqNumbers, setRfqNumbers] = useState("");
  const [rendomId, setRendomId] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [showSendButton, setShowSendButton] = useState(false);
  const [rfqSelectId, setRfqSelectId] = useState(null);
  const [rfqFloatId, setRfqFloatId] = useState(null);
  const [apiLoading, setapiLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState("");
  const [rfqVendorId, setRfqVendorId] = useState(null);
  const [getApi, setGetApi] = useState(false);
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [rfqDetailFloatID, setRfqDetailFloatID] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoadingReject, setBtnLoadingReject] = useState(false);

  const addNewVendor = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const res = async () => {
    setapiLoading(true);
    try {
      let apiResponse = await getRequest(`rfq-material-details/get-rfq-view-detail/?rfq_id=${id}`);

      console.log("apiResponse 012 ", apiResponse);

      setGetResponseData(apiResponse.data.data);
      setRfqNumbers(apiResponse.data.data.rfq_number);
      const rendomId = apiResponse.data.data.id;
      setRendomId(rendomId);

      setRfqSelectId(apiResponse?.data?.data?.rfq_material_details[0]?.id);
      setRfqVendorId(
        apiResponse?.data?.data?.total_quantity_by_site[0]?.site_wise[0]
          .material_wise[0].vendors_data
      );
      setRfqFloatId(
        apiResponse?.data?.data?.rfq_material_details[0]?.rfq_master
      );
      setRfqDetailFloatID(apiResponse?.data?.data?.rfq_details[0]?.float_rfq);

      const initialState = {
        rfq_master: rfqId,
        rfq_material_details:
          apiResponse?.data?.data?.total_quantity_by_site.map((item, ind) => ({
            rfq_city_wise: item.site_wise.map((site, siteIndex) => {
              console.log("site", site);

              return {
                purchase_requisition_site_name: site.site_id,
                site_wise_total_quantity: site.site_wise_total_quantity,
                site_wise_total_amount: site.site_wise_total_amount,
                rfq_material_wise: site.material_wise.map(
                  (material, materialTypeIndex) => {
                    console.log("material", material);
                    return {
                      // id: apiResponse.data.data.rfq_material_details[ind].id,
                      id: apiResponse.data.data.material_details[materialTypeIndex].rfq_material_id,
                      purchase_requisition_material:
                        material.purchase_requisition_material_id,
                      material_total_quantity: material.material_total_quantity,
                      amount: material.amount,
                      vendor: material.vendors_data.map((vendor) => vendor.id),
                    };
                  }
                ),
              };
            }),
          })),
      };

      setapiLoading(false);
      setState(initialState);
    } catch (err) {
      //ErrorNotificationMsg(err);
      setapiLoading(false);
    }
  };

  useEffect(() => {
    res();
    //getVendor();
    // getCurrency();
  }, [getApi, reload]);

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  // const handleVendorChange = (value, ind, materialTypeIndex, siteIndex) => {
  //   console.log('value', value, 'ind', ind, 'materialTypeIndex', materialTypeIndex, 'siteIndex', siteIndex);

  //   const updatedState = { ...state };
  //   if (
  //     updatedState.rfq_material_details &&
  //     updatedState.rfq_material_details[0]
  //   ) {
  //     updatedState.rfq_material_details[ind].rfq_city_wise[0].rfq_material_wise[
  //       materialTypeIndex
  //     ].rfq_site_wise_vendor[siteIndex].vendor = value;
  //     setState(updatedState);
  //     setSelectedVendors(value);
  //   } else {
  //     console.error("State structure doesn't match expected hierarchy");
  //   }
  // };

  const handleVendorChange = (value, ind, materialTypeIndex, siteIndex) => {
    console.log(
      "value",
      value,
      "ind",
      ind,
      "materialTypeIndex",
      materialTypeIndex,
      "siteIndex",
      siteIndex
    );

    const updatedState = { ...state };
    if (
      updatedState.rfq_material_details &&
      updatedState.rfq_material_details[ind] &&
      updatedState.rfq_material_details[ind].rfq_city_wise &&
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex] &&
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex].rfq_material_wise &&
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex].rfq_material_wise[materialTypeIndex]
    ) {
      // Update the vendor selection
      updatedState.rfq_material_details[ind].rfq_city_wise[siteIndex].rfq_material_wise[materialTypeIndex].vendor = value;

      // Set the updated state
      setState(updatedState);
      setSelectedVendors(value);
    } else {
      console.error(
        "State structure doesn't match expected hierarchy or indices are invalid"
      );
    }
  };


  const handleCheckboxChange = (ind, siteIndex, checked) => {
    if (checked) {
      const updatedState = { ...state };
      updatedState.rfq_material_details[ind].rfq_site_wise_vendor[
        siteIndex
      ].vendor =
        state?.rfq_material_details[ind]?.rfq_site_wise_vendor[
          siteIndex - 1
        ].vendor;
      setState(updatedState);
    }
  };
  console.log("getResponseData", getResponseData);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const action = queryParams.get('action');
  if (action === 'Approve') 
    {
      return <ApprovalForRFQ resetToken={resetToken} id={id} rfqNumber={rfqNumber} />;
    } 
    // else if(action === "Reject%20With%20Reason")
    //   {
    //   return <NewRFQApproval resetToken={resetToken} id={id} rfqNumber={rfqNumber} />;
    // } 
    else {
        // Optionally handle the case where action is not recognized
        return <NewRFQApproval resetToken={resetToken} id={id} rfqNumber={rfqNumber} />;
      }


   
  
  const handleRejectWithReason = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
    setShowRejectReason(true);
  };
  const handleSubmited = async () => {
    // const payload = {
    //   rfq_reject_reason: state.rfq_reject_reason,
    // };
    try {
      setBtnLoading(true)
      // Call your API to submit the reject reason
      // const response = await postRequest("purchase-requisition/pr-approval/" + resetToken + "/" + id + "/", payload);
      const response = await postRequest(
        "float-rfq/rfq-approval/" +
          resetToken +
          "/" +
          id +
          `/${rfqNumber}`+
          `/?action=Approve`
      );
      // Handle successful response
      // Optionally, you can reset the reject reason input field and hide it
      //setRejectReason("");
      setShowRejectReason(true);
      if (response.data.success) {
        //setAddedCompanyId(response.data.data.id);
        SuccessNotificationMsg("RFQ Approved Successfully");
      }
      navigate("/request-for-quotation/history");
      setBtnLoading(false);
    } catch (error) {
      // Handle error
      console.error("Error submitting reject reason:", error);
      setBtnLoading(false);
      // Optionally, you can display an error message to the user
    }
  };
  const handleSubmitRejectReason = async () => {
    console.log("abc")
    const payload = {
      rfq_reject_reason: state.rfq_reject_reason,
    };
    try {
    //  btnLoadingReject(true)
      // Call your API to submit the reject reason
      // const response = await postRequest("purchase-requisition/pr-approval/" + resetToken + "/" + id + "/", payload);
      const response = await postRequest(
        "float-rfq/rfq-approval/" +
          resetToken +
          "/" +
          id +
          `/${rfqNumber}`+
          `/?action=RejectWithReason`,
        payload
      );
      // Handle successful response
      // Optionally, you can reset the reject reason input field and hide it
      //setRejectReason("");
      setShowRejectReason(true);
      if (response.data.success) {
        //setAddedCompanyId(response.data.data.id);
        SuccessNotificationMsg("RFQ Rejected Successfully");
      }
      navigate("/request-for-quotation/history");
      //setBtnLoadingReject(false);
    } catch (error) {
      // Handle error
      console.error("Error submitting reject reason:", error);
      // Optionally, you can display an error message to the user
    }
  };
  const handleSubmitSaveDraft = async () => {
    const payload = {
      rfq_master: rfqId,
      rfq_material_details: state.rfq_material_details.map((item) => ({
        rfq_city_wise: item.rfq_city_wise.map((city) => ({
          rfq_material_wise: city.rfq_material_wise.map((material, index) => ({
            id: getResponseData.rfq_material_details[index].id,
            purchase_requisition_material:
              material.purchase_requisition_material,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor: material.rfq_site_wise_vendor.map((site) => ({
              purchase_requisition_site_name:
                site.purchase_requisition_site_name,
              site_wise_total_quantity: site.site_wise_total_quantity,
              site_wise_total_amount: site.site_wise_total_amount,
              vendor: site.vendor,
            })),
          })),
        })),
      })),
    };

    const payload2 = {
      rfq_master: rfqId,
      rfq_material_details: state.rfq_material_details.map((item) => ({
        rfq_city_wise: item.rfq_city_wise.map((city) => ({
          rfq_material_wise: city.rfq_material_wise.map((material, index) => ({
            id: getResponseData.rfq_material_details[index].id,
            purchase_requisition_material:
              material.purchase_requisition_material,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor: material.rfq_site_wise_vendor.map((site) => ({
              id: site.id,
              purchase_requisition_site_name:
                site.purchase_requisition_site_name,
              site_wise_total_quantity: site.site_wise_total_quantity,
              site_wise_total_amount: site.site_wise_total_amount,
              vendor: site.vendor,
            })),
          })),
        })),
      })),
    };

    try {
      let response;
      if (rfqVendorId === null) {
        response = await patchRequest(
          `rfq-material-details/${rfqFloatId}/create-float-rfq-draft/`,
          payload
        );
      } else {
        response = await patchRequest(
          `rfq-material-details/${rfqFloatId}/create-float-rfq-draft/`,
          payload2
        );
      }
      if (response.data.success) {
        setShowSendButton(true);
        setGetApi((prevState) => !prevState);
        SuccessNotificationMsg("RFQ Successfully Sent");

        navigate(`/request-for-quotation/history`);
      }
    } catch (error) {
      setapiLoading(false);
    }
  };

  const getVendor = async (data) => {
    await getRequest("rfq-material-details/get-vendor-by-company/", data).then(
      (response) => {
        setDropdownOptions(response.data.results.data);
      }
    );
  };

  console.log("state", state);

  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>RFQ Approval</h3>

            {/* <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">RFQ History</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>RFQ - Select Vendor</Breadcrumb.Item>
            </Breadcrumb> */}
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody selectvendor">
          <Spin spinning={apiLoading}>
            <Form>
              <Row gutter={16}>
                <Col className="TextFeild gutter-row">
                  <Space>
                    <label className="cp">RFQ Number</label>
                    <strong>{rfqNumbers}</strong>
                  </Space>
                </Col>
              </Row>

              <div className="formtable">
                <Row gutter={16} className="throw">
                  <Col style={{ width: "65px" }}>
                    <label className="th">Sr. No.</label>
                  </Col>
                  <Col style={{ width: "150px" }}>
                    <label className="th">City</label>
                  </Col>
                  <Col style={{ width: "150px" }}>
                    <label className="th">Site</label>
                  </Col>
                  <Col style={{ width: "150px" }}>
                    <label className="th">Item </label>
                  </Col>
                  <Col style={{ width: "80px" }}>
                    <label className="th">Quantity</label>
                  </Col>
                  <Col
                    style={{ width: "80px" }}
                    className="TextFeild gutter-row"
                  >
                    <label className="th">UoM.</label>
                  </Col>
                  <Col
                    style={{ width: "150px" }}
                    className="TextFeild gutter-row"
                  >
                    <label className="th">EST. Amount</label>
                  </Col>
                  <Col className="TextFeild gutter-row">
                    <label className="th">Bidder(s)</label>
                  </Col>
                  <Col
                    className="TextFeild gutter-row"
                    style={{ width: "65px" }}
                  >
                    <label className="th"></label>
                  </Col>
                </Row>
                {
                  <React.Fragment>
                    {getResponseData.total_quantity_by_site &&
                      getResponseData.total_quantity_by_site.map(
                        (data, ind) => {
                          // Iterate through each site in site_wise
                          return data.site_wise.map((siteData, siteIndex) => {
                            // Create a map to group materials by material type name
                            const materialMap = {};

                            siteData.material_wise.forEach((material) => {
                              if (
                                !materialMap[
                                material
                                  .purchase_requisition_material_type_name
                                ]
                              ) {
                                materialMap[
                                  material.purchase_requisition_material_type_name
                                ] = [];
                              }
                              materialMap[
                                material.purchase_requisition_material_type_name
                              ].push(material);
                            });

                            // Iterate through the grouped materials
                            return Object.entries(materialMap).map(
                              (
                                [materialTypeName, materials],
                                materialTypeIndex
                              ) => (
                                <React.Fragment
                                  key={`${siteData.site_id}-${materialTypeIndex}`}
                                >
                                  {materials.map(
                                    (materialData, materialDataIndex) => (
                                      <React.Fragment
                                        key={`material-${materialData.purchase_requisition_material_id}-${materialDataIndex}`}
                                      >
                                        <Row gutter={16}>
                                          <Col
                                            style={{ width: "65px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            {siteIndex === 0 &&
                                              materialTypeIndex === 0 && (
                                                <span>{ind + 1}</span>
                                              )}
                                          </Col>

                                          <Col
                                            style={{ width: "150px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            {siteIndex === 0 &&
                                              materialTypeIndex === 0 && (
                                                <span>
                                                  {data.site_wise_city_name}
                                                </span>
                                              )}
                                          </Col>

                                          <Col
                                            style={{ width: "155px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            {materialTypeIndex === 0 && (
                                              <span>{siteData.site_name}</span>
                                            )}
                                          </Col>

                                          <Col
                                            style={{ width: "150px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            <span>{materialTypeName}</span>
                                          </Col>

                                          <Col
                                            style={{ width: "80px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            <span>
                                              {
                                                materialData.material_total_quantity
                                              }
                                            </span>
                                          </Col>

                                          <Col
                                            style={{ width: "80px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            <span>
                                              {materialData.unit_of_measurement}
                                            </span>
                                          </Col>

                                          <Col
                                            style={{ width: "150px" }}
                                            className="TextFeild gutter-row"
                                          >
                                            <span>{`${currencySymbol} ${materialData.amount}`}</span>
                                          </Col>

                                          <Col className="TextFeild gutter-row">
                                            <Select
                                              mode="multiple"
                                              allowClear
                                              style={{ width: "450px" }}
                                              placeholder="Please select"
                                              disabled
                                              value={
                                                state?.rfq_material_details?.[
                                                  ind
                                                ]?.rfq_city_wise?.[siteIndex]
                                                  ?.rfq_material_wise?.[
                                                  materialTypeIndex
                                                ]?.vendor || []
                                              }
                                              onChange={(value) =>
                                                handleVendorChange(
                                                  value,
                                                  ind,
                                                  materialTypeIndex,
                                                  siteIndex
                                                )
                                              }
                                            >
                                              {materialData.vendors_data.map(
                                                (vendor) => (
                                                  <Option
                                                    key={vendor.id}
                                                    value={vendor.id}
                                                  >
                                                    {vendor.name}
                                                  </Option>
                                                )
                                              )}
                                            </Select>
                                          </Col>

                                          <Col
                                            className="TextFeild gutter-row"
                                            style={{ width: "65px" }}
                                          >
                                            <Tooltip
                                              color={colors}
                                              placement="right"
                                              title={
                                                <span style={{ color: "#fff" }}>
                                                  Add Vendor
                                                </span>
                                              }
                                            >
                                              {/* <Button
                                                type="text"
                                                icon={<PlusOutlined />}
                                                onClick={addNewVendor}
                                              ></Button> */}
                                            </Tooltip>
                                          </Col>
                                        </Row>
                                      </React.Fragment>
                                    )
                                  )}
                                </React.Fragment>
                              )
                            );
                          });
                        }
                      )}
                  </React.Fragment>
                }
                {/* <Col>
                  <Modal
                    width={"60%"}
                    title={t("Add Vendor Details")}
                    open={isModalOpen}
                    footer={[]}
                    wrapClassName="modal-wrapper"
                    visible={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                  >
                    <SelectVendorAddModal
                      handleCancel={handleCancel}
                      setReload={setReload}
                      reload={reload}
                    />
                  </Modal>
                </Col> */}
                <div className=" btnfooter">
                  <div className="approvereject">
                  <div className="btnwrp">
                  <ButtonField
                      className="SaveGradiantBtn w-auto"
                      type="primary"
                      name="Reject With Reason"
                     // htmlType="submit"
                      label="Reject With Reason"
                      //handleRejectWithReason={handleRejectWithReason}
                      // loading={btnLoading}
                      loading={btnLoadingReject}
                      onClick={()=>handleSubmitRejectReason()}
                    />
                    </div>
                    <div className="reasontextwrap">
                    <InputField
                      name="rfq_reject_reason"
                      // label="Reject Reason"
                      rules="Please Enter Reject Reason"
                      placeholder="Enter Reject Reason"
                      //handleInputChange={handleRejectWithReason}
                      handleInputChange={handleRejectWithReason}
                      // value={}
                    />
                  </div>
                  <div className="btnwrp">
                  <ButtonField
                    label="RFQ Approval"
                    htmlType="submit"
                    type="primary"
                    onClick={handleSubmited}
                    loading={btnLoading}
                     className="SaveGradiantBtn w-auto"
                  // className="GradiantBtn SendBtn"
                  />
                  </div>
                  </div>
                </div>
              </div>

            </Form>
          </Spin>
        </div>
      </section>
    </>
  );
};

export default PoOrderApprovalRejection;
